import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ReportService } from 'app/_services/report.service';

import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { BsModalService } from 'ngx-bootstrap';
import { TopContentDiscussService } from './top-content-discuss.service';
import { ProjectsService } from 'app/_services/projects.service';
import { BrandService } from 'app/views/brand-manage/brands.service';
const moment = require('moment');
@Component({
  selector: 'app-brands',
  templateUrl: './top-content-discuss.component.html',
  styleUrls: ['./top-content-discuss.component.scss']
})
export class TopContentDiscussComponent implements OnInit {
  projectId = "";
  typeAction = 'create';
  brandDropDownSettings: any;
  brandSelectedFilter = [];
  brandSelected = [];
  brands = [];
  sourceByTopic = "";

  discussProject = [];
  selectedDiscussProjects = [];

  // for excel
  dataReport1 = [];
  dataReport2 = [];
  // end for excel
  reportName = "";
  dataReport: Object;
  projectDropDownSettings: any;
  projectSelectedFilter = [];
  projectSelected = [];
  projects = [];
  notSpam = true;

  typeReport = 1;
  typeFilter = 1;
  typeReportFilter = 1;
  sizeTable = 10;
  dtOptions: DataTables.Settings = {};
  keywords = '';
  imageSrc: any;
  file: null;
  result: any;
  source_keywords = '';
  listBrands = [];
  dataList = [];
  dataTableShow = false;
  showReport = false;
  currentConfigItem: object;
  modalRef: BsModalRef;
  recommandModalRef: BsModalRef;
  daterange: any = {
    start: moment().subtract(7, "days").startOf('day'),
    end: moment().subtract(1, "days").endOf('day')
  };
  daterangeFilter: any = {
    start: moment().subtract(1, "days").startOf('day'),
    end: moment().subtract(1, "days").endOf('day')
  };
  options = {
    locale: { format: 'DD/MM/YYYY' },
    timePicker: false,
    timePicker24Hour: true,
    timePickerSeconds: true,
    alwaysShowCalendars: false,
    maxDate: moment().subtract(1, "days").endOf('day').toDate(),
    startDate: this.daterange.start,
    endDate: this.daterange.end
  };
  optionsFilter = {
    locale: { format: 'DD/MM/YYYY' },
    timePicker: false,
    timePicker24Hour: true,
    timePickerSeconds: true,
    alwaysShowCalendars: false,
    maxDate: moment().subtract(1, "days").endOf('day').toDate(),
    startDate: this.daterangeFilter.start,
    endDate: this.daterangeFilter.end
  };
  selectedDate(value: any, datepicker?: any) {
    datepicker.start = value.start.startOf('day');
    datepicker.end = value.end.endOf('day');
    this.daterange.start = value.start;
    this.daterange.end = value.end;
    this.daterange.label = value.label;
  }
  selectedDateFilter(value: any, datepicker?: any) {

    datepicker.start = value.start.startOf('day');
    datepicker.end = value.end.endOf('day');
    this.daterangeFilter.start = value.start;
    this.daterangeFilter.end = value.end;
    this.optionsFilter = {
      locale: { format: 'DD/MM/YYYY' },
      timePicker: false,
      timePicker24Hour: true,
      timePickerSeconds: true,
      alwaysShowCalendars: false,
      maxDate: moment().subtract(1, "days").endOf('day').toDate(),
      startDate: this.daterangeFilter.start,
      endDate: this.daterangeFilter.end
    };

  }

  selectedProjects = [];

  arrTopContentDisscuss1 = [];
  arrTopContentDisscuss2 = [];

  recommandDiscussTopic = {
    table1: [],
    table2: []
  };

  pageSizeRecommand = 15;
  currentPageRecommand = 1;
  totalRecommandPost = 15;


  constructor(
    private projectsService: ProjectsService,
    private toastrService: ToastrService,
    private brandReportService: TopContentDiscussService,
    private brandService: BrandService,
    private modalService: BsModalService,
    private reportService: ReportService
  ) {
    this.getDataFromServer();
    this.getProject();
    this.getReportManager();
  }

  ngOnInit(): void {
    this.brandDropDownSettings = {
      singleSelection: true,
      text: 'Chọn thương hiệu',
      selectAllText: 'Chọn tất cả',
      unSelectAllText: 'Bỏ chọn tất cả',
      enableSearchFilter: false,
      badgeShowLimit: 2,
    };
    this.projectDropDownSettings = {
      singleSelection: false,
      text: 'Chọn chủ đề',
      selectAllText: 'Chọn tất cả',
      unSelectAllText: 'Bỏ chọn tất cả',
      enableSearchFilter: false,
      badgeShowLimit: 2,
    };
    this.dtOptions = {
      pagingType: 'full_numbers',
      ordering: true,
      searching: true,
      paging: true,
      language: {
        infoEmpty: 'Không tìm thấy dữ liệu',
        infoFiltered: '(trong _MAX_ )',
        info: 'Hiển thị _START_ - _END_ trên _TOTAL_',
        lengthMenu: 'Hiển thị _MENU_ ',
        search: 'Tìm kiếm',
        zeroRecords: 'Không có dữ liệu !',
        paginate: {
          first: '<<',
          previous: '<',
          next: '>',
          last: '>>',
        }
      },
      columnDefs: [
        { 'targets': [0, 1, 2, 3, 4, 5], 'searchable': true }
      ]
    };
  };

  showRecommentPost(modalRef) {
    this.getRecommandPost()
    this.recommandModalRef = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'custom-modal-1'
    });
  }

  onProjectSelectedChange() {

  }

  projectSelectedChange() {
    this.projectsService.getProjectDiscussionByProject({ projects: this.projectSelected }).subscribe(res => {
      this.discussProject = [];
      this.selectedDiscussProjects = [];
      if (res.success) {
        res.data.projectsDiscussion
          .forEach(element => {
            let obj = {
              id: element._id,
              itemName: element.name,
              value: element.name
            };
            this.discussProject.push(obj);
          });
      }
    })
  }

  checkExitsRecommand(item) {
    let check = false;
    for (var i = 0; i < this.arrTopContentDisscuss1.length; i++) {
      if (this.arrTopContentDisscuss1[i].link == item.link) {
        check = true;
      }
    }
    return check;
  }
  checkExitsRecommand2(item) {
    let check = false;
    for (var i = 0; i < this.arrTopContentDisscuss2.length; i++) {
      if (this.arrTopContentDisscuss2[i].link == item.link) {
        check = true;
      }
    }
    return check;
  }

  clickSaveRecommand(item) {
    this.arrTopContentDisscuss1.push(item);
    const res = this.arrTopContentDisscuss1.sort(({ numDiscuss: a }, { numDiscuss: b }) => b - a);
    this.arrTopContentDisscuss1 = res;
  }
  clickSaveRecommand2(item) {
    this.arrTopContentDisscuss2.push(item);
    const res = this.arrTopContentDisscuss2.sort(({ numDiscuss: a }, { numDiscuss: b }) => b - a);
    this.arrTopContentDisscuss2 = res;
  }

  clickRemoveRecommand(item) {
    for (var i = 0; i < this.arrTopContentDisscuss1.length; i++) {
      if (this.arrTopContentDisscuss1[i].link == item.link) {
        this.arrTopContentDisscuss1.splice(i, 1);
      }
    }
    const res = this.arrTopContentDisscuss1.sort(({ numDiscuss: a }, { numDiscuss: b }) => b - a);
    this.arrTopContentDisscuss1 = res;
  }
  clickRemoveRecommand2(item) {
    for (var i = 0; i < this.arrTopContentDisscuss2.length; i++) {
      if (this.arrTopContentDisscuss2[i].link == item.link) {
        this.arrTopContentDisscuss2.splice(i, 1);
      }
    }
    const res = this.arrTopContentDisscuss2.sort(({ numDiscuss: a }, { numDiscuss: b }) => b - a);
    this.arrTopContentDisscuss2 = res;
  }

  clickSaveDataReport() {
    this.dataReport["data"] = {};
    this.dataReport["data"] = {
      size: this.sizeTable,
      arrTopContentDisscuss1: this.arrTopContentDisscuss1,
      arrTopContentDisscuss2: this.arrTopContentDisscuss2,
      type: this.typeFilter,
      headerDisscuss1: (this.typeFilter == 1) ? "Lượng chia sẻ" : "Lượng thảo luận",
      headerDisscuss2: (this.typeFilter == 1) ? "Lượng bình luận" : "Lượng thảo luận"
    };
    // this.dataReport = {};
    // this.dataReport = copy;
    this.recommandModalRef.hide();
  }

  showPreviewReport(item, modalRef) {
    this.typeAction = 'view';
    this.dataReport = {};
    // let await1s = await this.resolveAfter1Seconds()
    this.dataReport = JSON.parse(JSON.stringify(item));
    this.modalRef = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'custom-modal'
    });
  }

  showCreateReport(modalRef) {
    this.typeAction = 'create';
    this.dataReport = {};
    this.modalRef = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'custom-modal'
    });
  }

  modalRefHide(previewModal) {
    this.modalRef.hide();
    this.modalRef = this.modalService.show(previewModal, {
      keyboard: false,
      backdrop: 'static',
      class: 'custom-modal'
    });
  }
  getProject() {
    this.projectsService.index().subscribe(response => {
      if (response.success) {
        response.data.projects.forEach(element => {
          let projectItem = {
            id: element._id,
            itemName: element.name,
            value: element.name
          };
          this.projects.push(projectItem);
        });
      }
    });

  }

  getDataFromServer() {
    this.dataTableShow = false;
    this.brandReportService.getAll().subscribe(res => {
      if (res.success) {
        res.data.forEach(element => {
          let obj = {
            id: element._id,
            itemName: element.name,
            value: element.name
          };
          this.brands.push(obj);
        });
      } else {
        this.toastrService.error('Lỗi hệ thống, Vui lòng liên hệ admin', ' Thông báo')
      }
    });
  }

  getReportManager() {
    this.dataTableShow = false;
    let type = "day";
    if (this.typeReport == 2) {
      type = "week";
    } else if (this.typeReport == 3) {
      type = "month";
    } else if (this.typeReport == 4) {
      type = "year";
    } else if (this.typeReport == 5) {
      type = "option";
    }
    let filter = {
      gte: this.daterange.start.valueOf(),
      lte: this.daterange.end.valueOf(),
      projects: this.projectSelected,
      brands: this.brandSelected,
      typeReport: type,
      report_code: ["BCTCD"]
    };
    this.brandReportService.getAllReportManager(filter).subscribe(response => {
      this.dataTableShow = true;
      this.dataList = response.data;
    });
  }

  pageChange(number) {
    this.recommandDiscussTopic = {
      table1: [],
      table2: []
    };
    this.currentPageRecommand = number;
    this.getRecommandPost();
  }

  getRecommandPost() {
    let type = "day";
    if (this.typeReportFilter == 2) {
      type = "week";
    } else if (this.typeReportFilter == 3) {
      type = "month";
    } else if (this.typeReportFilter == 4) {
      type = "year";
    } else if (this.typeReportFilter == 5) {
      type = "option";
    }
    let filter = {
      gte: this.daterangeFilter.start.valueOf(),
      lte: this.daterangeFilter.end.valueOf(),
      projects: this.projectSelectedFilter,
      brands: this.brandSelectedFilter,
      type: type,
      typeFilter: this.typeFilter,
      notSpam: this.notSpam
    };

    this.brandReportService.getReport({ filter: filter, size: this.sizeTable, from: (this.currentPageRecommand - 1) * this.pageSizeRecommand }).subscribe(response => {

      this.totalRecommandPost = response.data.totalContentDisscuss1 > response.data.totalContentDisscuss2 ? response.data.totalContentDisscuss1 : response.data.totalContentDisscuss2;
      let topContentDisscuss1 = response.data.topContentDisscuss1;
      let topContentDisscuss2 = response.data.topContentDisscuss2;
      let table1 = [];
      for (var i = 0; i < topContentDisscuss1.length; i++) {
        let obj = {
          sourceName: topContentDisscuss1[i]["_source"]["sourceName"] || topContentDisscuss1[i]["_source"]["groupName"] || '',
          sourceId: topContentDisscuss1[i]["_source"]["sourceId"] || topContentDisscuss1[i]["_source"]["groupId"] || '',
          link: this.getLink(topContentDisscuss1[i]["_source"]),
          content: topContentDisscuss1[i]["_source"]["message"],
          numDiscuss: (this.typeFilter == 1) ? parseInt(topContentDisscuss1[i]["_source"]["numShares"]) : (parseInt(topContentDisscuss1[i]["_source"]["numShares"]) + parseInt(topContentDisscuss1[i]["_source"]["numComments"]) + parseInt(topContentDisscuss1[i]["_source"]["numLikes"])),
          created_Date: topContentDisscuss1[i]["_source"]["createDate"],
        };
        table1.push(obj);
      }

      let table2 = [];

      for (var i = 0; i < topContentDisscuss2.length; i++) {
        let obj = {
          sourceName: topContentDisscuss2[i]["_source"]["sourceName"] || topContentDisscuss2[i]["_source"]["groupName"] || '',
          sourceId: topContentDisscuss2[i]["_source"]["sourceId"] || topContentDisscuss2[i]["_source"]["groupId"] || '',
          link: this.getLink(topContentDisscuss2[i]["_source"]),
          content: topContentDisscuss2[i]["_source"]["message"],
          numDiscuss: (this.typeFilter == 1) ? parseInt(topContentDisscuss2[i]["_source"]["numComments"]) : (parseInt(topContentDisscuss2[i]["_source"]["numShares"]) + parseInt(topContentDisscuss2[i]["_source"]["numComments"]) + parseInt(topContentDisscuss2[i]["_source"]["numLikes"])),
          created_Date: topContentDisscuss2[i]["_source"]["createDate"],
        };
        table2.push(obj);
      }
      this.recommandDiscussTopic = {
        table1: table1,
        table2: table2
      };
    });
  }

  clickReport() {
    if (this.projectSelectedFilter.length == 0 && this.brandSelectedFilter.length == 0) {
      this.toastrService.warning("Bạn phải chọn thương hiệu hoặc chủ đề", "Thông báo!");
      return;
    }

    // let timeRange = Math.ceil((this.daterangeFilter.end.valueOf() - this.daterangeFilter.start.valueOf()) / (24 * 60 * 60 * 1000));
    // if (timeRange > 60) {
    //   this.toastrService.warning("Khoảng thời gian chọn không được quá 60 ngày!", "Thông báo!");
    //   return;
    // }

    this.dataReport = {};
    let type = "day";
    if (this.typeReportFilter == 2) {
      type = "week";
    } else if (this.typeReportFilter == 3) {
      type = "month";
    } else if (this.typeReportFilter == 4) {
      type = "year";
    } else if (this.typeReportFilter == 5) {
      type = "option";
    }
    let filter = {
      gte: this.daterangeFilter.start.valueOf(),
      lte: this.daterangeFilter.end.valueOf(),
      discussProjects: this.selectedDiscussProjects,
      projects: this.projectSelectedFilter,
      brands: this.brandSelectedFilter,
      type: type,
      typeFilter: this.typeFilter,
      sourceByTopic: this.sourceByTopic,
      notSpam: this.notSpam
    };
    this.brandReportService.getReport({ filter: filter, size: this.sizeTable, from: 0 }).subscribe(response => {
      let data = response.data;
      if (data) {
        this.dataReport = {
          report_desc: "Báo cáo Top nội dung thảo luận nhiều nhất",
          report_type: type,
          report_name: "Báo cáo Top nội dung thảo luận nhiều nhất từ ngày " + this.daterangeFilter.start.format('DD/MM/YYYY') + " đến ngày " + this.daterangeFilter.end.format('DD/MM/YYYY'),
          report_project: this.projectSelectedFilter,
          report_brand: this.brandSelectedFilter,
          report_start_date: new Date(this.daterangeFilter.start.valueOf()),
          report_end_date: new Date(this.daterangeFilter.end.valueOf()),
          report_code: "BCTCD",
        };
        let topContentDisscuss1 = data.topContentDisscuss1;
        this.arrTopContentDisscuss1 = [];

        for (var i = 0; i < topContentDisscuss1.length; i++) {
          let obj = {
            sourceName: topContentDisscuss1[i]["_source"]["sourceName"] || topContentDisscuss1[i]["_source"]["groupName"] || '',
            sourceId: topContentDisscuss1[i]["_source"]["sourceId"] || topContentDisscuss1[i]["_source"]["groupId"] || '',
            link: this.getLink(topContentDisscuss1[i]["_source"]),
            content: topContentDisscuss1[i]["_source"]["message"],
            numDiscuss: (this.typeFilter == 1) ? parseInt(topContentDisscuss1[i]["_source"]["numShares"]) : (parseInt(topContentDisscuss1[i]["_source"]["numShares"]) + parseInt(topContentDisscuss1[i]["_source"]["numComments"]) + parseInt(topContentDisscuss1[i]["_source"]["numLikes"])),
            created_Date: topContentDisscuss1[i]["_source"]["createDate"],
          };
          this.arrTopContentDisscuss1.push(obj);
        }
        this.dataReport1 = JSON.parse(JSON.stringify(this.arrTopContentDisscuss1));

        let topContentDisscuss2 = data.topContentDisscuss2;
        this.arrTopContentDisscuss2 = [];

        for (var i = 0; i < topContentDisscuss2.length; i++) {
          let obj = {
            sourceName: topContentDisscuss2[i]["_source"]["sourceName"] || topContentDisscuss2[i]["_source"]["groupName"] || '',
            sourceId: topContentDisscuss2[i]["_source"]["sourceId"] || topContentDisscuss2[i]["_source"]["groupId"] || '',
            link: this.getLink(topContentDisscuss2[i]["_source"]),
            content: topContentDisscuss2[i]["_source"]["message"],
            numDiscuss: (this.typeFilter == 1) ? parseInt(topContentDisscuss2[i]["_source"]["numComments"]) : (parseInt(topContentDisscuss2[i]["_source"]["numShares"]) + parseInt(topContentDisscuss2[i]["_source"]["numComments"]) + parseInt(topContentDisscuss2[i]["_source"]["numLikes"])),
            created_Date: topContentDisscuss2[i]["_source"]["createDate"],

          };
          this.arrTopContentDisscuss2.push(obj);
        }
        this.dataReport2 = JSON.parse(JSON.stringify(this.arrTopContentDisscuss2));

        this.dataReport["data"] = {
          size: this.sizeTable,
          arrTopContentDisscuss1: this.arrTopContentDisscuss1,
          arrTopContentDisscuss2: this.arrTopContentDisscuss2,
          type: this.typeFilter,
          headerDisscuss1: (this.typeFilter == 1) ? "Lượng chia sẻ" : "Lượng thảo luận",
          headerDisscuss2: (this.typeFilter == 1) ? "Lượng bình luận" : "Lượng thảo luận"
        };
      }
    });
    // console.log(filter);
  }

  getLink(source) {
    if (source.docType == 'user_post' || source.docType == 'page_post' || source.docType == 'group_post') {
      return `https://www.facebook.com/${source.docId}`;
    } else {
      return source.link;
    }
  }

  exportExcel() {
    let data = [];
    let sheet1Name = this.typeFilter == 1 ? 'Top 10 Nội Dung Được Chia Sẻ Nhiều Nhất' : 'TOP CÁC NỘI DUNG TÍCH CỰC ĐƯỢC THẢO LUẬN NHIỀU NHẤT';
    let sheet2Name = this.typeFilter == 1 ? 'Top 10 Nội Dung Được Bình Luận Nhiều Nhất' : 'TOP CÁC NỘI DUNG TIÊU CỰC ĐƯỢC THẢO LUẬN NHIỀU NHẤT';

    let sheet1Col = this.typeFilter == 1 ? 'Lượng chia sẻ' : 'Lượng Thảo Luận';
    let sheet2Col = this.typeFilter == 1 ? 'Lượng bình luận' : 'Lượng Thảo Luận';
    let header1 = [{ start: 1 }, { name: "STT" }, { name: "Source Name" }, { name: "Source Id" }, { name: "Link" }, { name: "Nội dung" }, { name: sheet1Col }, { name: "Thời gian đăng" }];
    let header2 = [{ start: 1 }, { name: "STT" }, { name: "Source Name" }, { name: "Source Id" }, { name: "Link" }, { name: "Nội dung" }, { name: sheet2Col }, { name: "Thời gian đăng" }];
    let sheet1 = { name: sheet1Name, header: [header1], data: this.dataReport1 };
    let sheet2 = { name: sheet2Name, header: [header2], data: this.dataReport2 };
    data.push(sheet1, sheet2);
    this.reportService.exportReportToExcel(data, 'Báo cáo top nội dung thảo luận');
  }

  clickSave() {
    if (this.dataReport) {
      if (this.reportName == "") {
        this.toastrService.warning("Bạn phải nhập tiêu đề cho báo cáo!", "Thông báo!");
        return;
      }
      this.dataReport["report_title"] = this.reportName.trim();
      this.brandReportService.createReportManager(this.dataReport).subscribe(response => {
        if (response.success) {
          this.toastrService.success("Đã tạo báo cáo thành công!", "Thông báo!");
          this.getReportManager();
        } else {
          this.toastrService.warning(response.msg, "Thông báo!");
        }
        this.closeModal();
      });
    } else {
      this.toastrService.warning("Không có dữ liệu báo cáo cần cập nhật!", "Thông báo!");
    }
  }
  clickDeleteItem(item, modalRef) {
    this.modalRef = this.modalService.show(modalRef);
    this.currentConfigItem = JSON.parse(JSON.stringify(item));
  }
  clickSaveConfirm(modalRef) {
    if (!this.dataReport) {
      this.toastrService.warning("Không có dữ liệu báo cáo cần cập nhật!", "Thông báo!");
      return;
    }
    this.reportName = "";
    this.modalRef.hide();
    this.modalRef = this.modalService.show(modalRef);
  }

  deleteReport() {
    this.brandReportService.deleteReport(this.currentConfigItem['_id']).subscribe(res => {
      if (res.success) {
        this.getReportManager();
        this.toastrService.success('Xóa báo cáo thành công !', 'Thông báo');
        this.closeModal();
      } else {
        this.toastrService.error('Xóa báo cáo thất bại !', 'Thông báo');
      }
    });
  }
  closeModal() {
    this.modalRef.hide();
  }



  onItemSelect(item: any, type: 'brand' | 'project') {
    // console.log("onItemSelect : ", item, 'type: ', type);
    if (type == 'project') {
      if (!this.projectSelected.find(it => it.id === item.id) && type == 'project') {
        this.projectSelected.push(item);
      }
      this.projectSelectedChange();
    }
  }
  OnItemDeSelect(item: any, type: 'brand' | 'project') {
    // console.log("OnItemDeSelect : ", item)
    if (type == 'project') {
      this.projectSelected = this.projectSelected.filter(it => it.id !== item.id);
      this.projectSelectedChange();
    }
  }

  onSelectAll(items: any, type: 'brand' | 'project') {
    // console.log("onSelectAll : ", items)
    if (type == 'project') {
      this.projectSelected = items;
      this.projectSelectedChange();
    }
  }

  onDeSelectAll(items: any, type: 'brand' | 'project') {
    // console.log("onDeSelectAll : ", items)
    if (type == 'project') {
      this.projectSelected = [];
      this.projectSelectedChange();
    }
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-module/top-content-discuss/top-content-discuss.component.ts